// Page up / page down toggle pinned to the right edge of every page.
//
// The site has very long pages (price board, guides, index tables) and dragging
// the scrollbar is a poor experience on a trackpad or touch screen. These two
// buttons move the viewport one screen at a time, plus a jump-to-top button once
// the visitor is deep in the page.
import { useEffect, useState } from "react";
import { ChevronUp, ChevronDown, ArrowUp } from "lucide-react";

export function ScrollPager() {
  const [deep, setDeep] = useState(false);

  useEffect(() => {
    const onScroll = () => setDeep(window.scrollY > window.innerHeight);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const page = (dir: 1 | -1) => {
    const step = Math.max(window.innerHeight - 120, 240);
    window.scrollBy({ top: dir * step, behavior: "smooth" });
  };

  const btn =
    "flex h-10 w-10 items-center justify-center rounded-full border border-border/60 bg-background/85 text-foreground shadow-lg backdrop-blur transition hover:border-primary/60 hover:text-primary";

  return (
    <div
      className="fixed right-3 top-1/2 z-[60] -translate-y-1/2 flex-col gap-2 print:hidden hidden sm:flex"
      role="group"
      aria-label="Page navigation"
    >
      <button type="button" className={btn} onClick={() => page(-1)} aria-label="Page up">
        <ChevronUp className="h-5 w-5" aria-hidden="true" />
      </button>
      <button type="button" className={btn} onClick={() => page(1)} aria-label="Page down">
        <ChevronDown className="h-5 w-5" aria-hidden="true" />
      </button>
      {deep && (
        <button
          type="button"
          className={btn}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Back to top of page"
        >
          <ArrowUp className="h-4 w-4" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
